import { PortalUtils } from '@powerduck/common/utils/utils';
import { AppConfig } from './app-config';
import { AppRouter } from './app/router';
import AppAgnosticFactory from './app/app-agnostic-factory';
import { AppState } from './app-state';

AppAgnosticFactory.create().then((appData) => {
	const { app } = appData;
	const initApp = () => {
		AppRouter.currentRouter.isReady().then(() => {
			AppState._vueInstance = app.mount('#app');

			if (PortalUtils.treatAsMobileDevice()) {
				const loaderContainer = $('.mobileLoader');
				loaderContainer.addClass('mobileLoaderActive').html(AppConfig.blockerHtml);
			}
		});
	};

	if ((window as any).appAutoInit == false) {
		(window as any).initApp = initApp;
	} else {
		initApp();
	}
});
